interface FeedbackElement {
	focus(options?: FocusOptions): void;
	scrollIntoView(options?: ScrollIntoViewOptions): void;
}

export function revealFeedback(element: FeedbackElement | null) {
	revealElement(element, 'center');
}

export function revealSection(element: FeedbackElement | null) {
	revealElement(element, 'start');
}

export function shouldShowDatePlaceholder(value: string, focused: boolean): boolean {
	return !value && !focused;
}

function revealElement(element: FeedbackElement | null, block: ScrollLogicalPosition) {
	if (!element) return;
	element.focus({ preventScroll: true });
	element.scrollIntoView({ behavior: 'smooth', block });
}
